import React from 'react'
import { AboutCompany } from '../Components/AboutComponents/AboutCompany.js'
import { AboutTeam } from '../Components/AboutComponents/AboutTeam.js'
import styles from './About.module.css';

export const About = () => {
    return (
        // Added a wrapper to apply the animated background to the whole page
        <div className={styles.mainContainer}>
            <div className={styles.contentWrapper}>
                <AboutCompany />
                <AboutTeam />
            </div>
        </div>
    )
}
